<template src="./Link.html"></template>

<script>
  import Image from '@/components/Image/Image'

  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      url: {
        type: String,
        required: true
      },
      external: {
        type: Boolean,
        default: false
      },
      behaviour: {
        type: String
      },
      eyeCatcher: {
        type: String
      },
      image: {
        type: Object
      }
    },
    components: {
      'hp-image': Image
    }
  }
</script>
